import FreeCouponDetailPageView from 'src/pages/FreeCouponPage/FreeCouponDetailPage/view'
import { QueryClient } from '@tanstack/react-query'
import {
  freeCouponDetailQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { FreeCouponDetailSpace } from 'src/types/api'
import { Params } from 'react-router-dom'
import useParamsType, { MatchParams } from 'src/hooks/useParamsType.hook'
import { useState } from 'react'

export interface FreeCouponDetailPageProps {
  freeCouponDetailData?: FreeCouponDetailSpace.Response
  isBottomSheetOpen: boolean
  setIsBottomSheetOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const freeCouponDetailPageLoader =
  (queryClient: QueryClient) =>
  async ({ params: { free_coupon_Idx } }: { params: Params<keyof MatchParams> }) => {
    return Promise.allSettled([
      await queryClient.ensureQueryData(
        freeCouponDetailQueryOption({ Idx: Number(free_coupon_Idx!) }),
      ),
    ])
  }

const FreeCouponDetailPage = () => {
  const { free_coupon_Idx } = useParamsType()
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false)

  const { data: freeCouponDetailQueryData } = useCustomQuery<FreeCouponDetailSpace.Response>(
    freeCouponDetailQueryOption({ Idx: Number(free_coupon_Idx) }),
  )

  const props: FreeCouponDetailPageProps = {
    freeCouponDetailData: freeCouponDetailQueryData?.Body,
    isBottomSheetOpen,
    setIsBottomSheetOpen,
  }
  return <FreeCouponDetailPageView {...props} />
}
export default FreeCouponDetailPage
